/* CD Island Neon — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var f = (window.theme && theme.moneyFormat) || '{{amount}}';
    var n = (cents / 100);
    function fmt(num, dec, thou, point) {
      var s = num.toFixed(dec).split('.');
      s[0] = s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      return s[0] + (s[1] ? point + s[1] : '');
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return fmt(n, 2, ',', '.');
        case 'amount_no_decimals': return fmt(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(n, 2, "'", '.');
        default: return fmt(n, 2, ',', '.');
      }
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ---------- Header ---------- */
  var header = $('[data-header]');
  var toTop = $('[data-to-top]');
  function onScroll() {
    var y = window.scrollY;
    if (header) header.classList.toggle('is-scrolled', y > 10);
    if (toTop) toTop.classList.toggle('is-visible', y > 600);
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  if (toTop) toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });

  /* ---------- Light / dark mode ---------- */
  $$('[data-theme-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var next = document.documentElement.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', next);
      try { localStorage.setItem('cdi-theme', next); } catch (e) {}
    });
  });

  /* ---------- Overlays: menu, search, cart ---------- */
  var overlay = $('[data-overlay]');
  var menu = $('[data-mobile-menu]');
  var drawer = $('[data-cart-drawer]');
  var filters = $('[data-filters]');
  var search = $('[data-search]');

  function lock(on) { document.body.style.overflow = on ? 'hidden' : ''; }
  function setOpen(el, on) {
    if (!el) return;
    el.classList.toggle('is-open', on);
    el.setAttribute('aria-hidden', on ? 'false' : 'true');
  }
  function closeAll() {
    [menu, drawer, filters].forEach(function (el) { setOpen(el, false); });
    if (overlay) overlay.hidden = true;
    if (search) search.hidden = true;
    lock(false);
  }
  function openPanel(el) {
    closeAll(); setOpen(el, true);
    if (overlay) overlay.hidden = false;
    lock(true);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-menu]')) return openPanel(menu);
    if (t.closest('[data-close-menu]') || t.closest('[data-close-drawer]') || t === overlay) return closeAll();
    if (t.closest('[data-toggle-filters]') && filters) return filters.classList.contains('is-open') ? closeAll() : openPanel(filters);
    if (t.closest('[data-open-search]')) {
      closeAll(); search.hidden = false; lock(true);
      setTimeout(function () { var i = $('[data-search-input]'); if (i) i.focus(); }, 50);
      return;
    }
    if (t.closest('[data-close-search]')) return closeAll();
    var link = t.closest('[data-cart-link]');
    if (link && window.theme.cartDrawer && !/\/cart/.test(location.pathname)) { e.preventDefault(); renderCart().then(function () { openPanel(drawer); }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- Predictive search ---------- */
  var sInput = $('[data-search-input]'), sOut = $('[data-search-results]'), sTimer;
  if (sInput && sOut) {
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (q.length < 2) { sOut.innerHTML = ''; return; }
      sTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { sOut.innerHTML = '<p class="muted center">No products found for “' + esc(q) + '”</p>'; return; }
            sOut.innerHTML = items.map(function (p) {
              return '<a class="sr" href="' + p.url + '"><img src="' + sized(p.image, 120) + '" alt="" width="56" height="56"><div><b>' + esc(p.title) + '</b><span>' + esc(p.vendor || '') + ' ' + formatMoney(parseFloat(p.price) * 100) + '</span></div></a>';
            }).join('') + '<a class="link-arrow" style="justify-content:center;margin-top:8px" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results</a>';
          }).catch(function () {});
      }, 250);
    });
  }

  /* ---------- Scroll reveal ---------- */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- Hero slider ---------- */
  $$('[data-slider]').forEach(function (root) {
    var slides = $$('[data-slide]', root), dots = $$('[data-dot]', root), i = 0, timer;
    if (slides.length < 2) return;
    var delay = parseInt(root.dataset.delay, 10) || 6000, auto = root.dataset.autoplay === 'true';
    function go(n) {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
    }
    function play() { if (auto && !reduceMotion) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, delay); } }
    function stop() { clearInterval(timer); }
    $('[data-next]', root).addEventListener('click', function () { go(i + 1); play(); });
    $('[data-prev]', root).addEventListener('click', function () { go(i - 1); play(); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    var sx = 0;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1)); play(); }, { passive: true });
    play();
  });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date((el.dataset.countdown || '').replace(' ', 'T')).getTime();
    if (isNaN(end)) return;
    var d = $('[data-d]', el), h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, end - Date.now()), sec = Math.floor(diff / 1000);
      d.textContent = pad(Math.floor(sec / 86400)); h.textContent = pad(Math.floor(sec % 86400 / 3600));
      m.textContent = pad(Math.floor(sec % 3600 / 60)); s.textContent = pad(sec % 60);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Cart ---------- */
  var countEls = $$('[data-cart-count]');
  function setCount(n) {
    countEls.forEach(function (c) { c.textContent = n; c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); });
  }
  function cartRequest(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function renderCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      setCount(cart.item_count);
      var items = $('[data-cart-items]'), foot = $('[data-cart-foot]'), txt = $('[data-cart-count-text]');
      if (!items) return cart;
      if (txt) txt.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      if (!cart.items.length) {
        items.innerHTML = '<div class="cart-empty"><p>' + esc((theme.strings && theme.strings.emptyCart) || 'Your cart is empty.') + '</p><a class="btn btn--primary" href="/collections/all">Start shopping</a></div>';
        foot.innerHTML = '';
      } else {
        items.innerHTML = cart.items.map(function (it) {
          return '<div class="cart-line">' +
            '<a href="' + it.url + '"><img src="' + sized(it.image, 160) + '" alt="' + esc(it.title) + '" width="76" height="76" loading="lazy"></a>' +
            '<div><a class="cart-line__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
            (it.variant_title ? '<p class="cart-line__meta">' + esc(it.variant_title) + '</p>' : '<p class="cart-line__meta"></p>') +
            '<div class="cart-line__row"><div class="qty">' +
            '<button type="button" data-line-qty="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">−</button>' +
            '<input type="number" value="' + it.quantity + '" readonly aria-label="Quantity">' +
            '<button type="button" data-line-qty="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
            '<b>' + formatMoney(it.final_line_price) + '</b></div>' +
            '<button type="button" class="cart-line__remove" data-line-qty="' + it.key + '" data-qty="0">Remove</button></div></div>';
        }).join('');
        foot.innerHTML = '<p class="sum-row"><span>Subtotal</span><b>' + formatMoney(cart.total_price) + '</b></p>' +
          '<p class="muted" style="margin:0;font-size:.82rem">Taxes & shipping calculated at checkout.</p>' +
          '<a class="btn btn--primary btn--lg btn--block" href="/checkout">' + esc((theme.strings && theme.strings.checkout) || 'Checkout') + '</a>' +
          '<a class="btn btn--ghost btn--block" href="/cart">View cart</a>';
      }
      // free shipping bar
      var bar = $('[data-ship-bar]');
      if (bar && theme.freeShipping > 0) {
        var goal = theme.freeShipping * 100, left = goal - cart.total_price;
        $('[data-ship-text]', bar).innerHTML = left > 0 && cart.item_count
          ? 'Add <b>' + formatMoney(left) + '</b> more for <b>free delivery</b> 🚚'
          : (cart.item_count ? '🎉 You\'ve unlocked <b>free delivery</b>!' : 'Free delivery on orders over <b>' + formatMoney(goal) + '</b>');
        $('[data-ship-fill]', bar).style.width = Math.min(100, cart.total_price / goal * 100) + '%';
      }
      return cart;
    });
  }

  function afterAdd() {
    if (!window.theme.cartDrawer) { location.href = theme.routes.cart; return; }
    return renderCart().then(function () { openPanel(drawer); });
  }

  // Quick add buttons on cards
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    cartRequest('/cart/add.js', { id: parseInt(btn.dataset.variantId, 10), quantity: 1 })
      .then(afterAdd).catch(function (err) { alert((err && err.description) || 'Could not add to cart'); })
      .then(function () { btn.classList.remove('is-loading'); });
  });

  // Drawer line quantity
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]');
    if (!b) return;
    cartRequest('/cart/change.js', { id: b.dataset.lineQty, quantity: parseInt(b.dataset.qty, 10) }).then(renderCart).catch(function () {});
  });

  // Cart page quantity buttons
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input'), v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.delta, 10));
    input.value = v;
    var form = b.closest('form'); var u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = 'Update'; form.appendChild(u); form.submit();
  });

  if (drawer) renderCart();

  /* ---------- Product page ---------- */
  var pdp = $('[data-product]');
  if (pdp) {
    var variantsEl = $('[data-variants]', pdp), variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var form = $('[data-product-form]', pdp), vInput = $('[data-variant-input]', pdp);
    var atc = $('[data-atc]', pdp), atcText = $('[data-atc-text]', pdp), errEl = $('[data-form-error]', pdp);

    function setMedia(id) {
      $$('.pdp__slide', pdp).forEach(function (s) { s.classList.toggle('is-active', String(s.dataset.mediaId) === String(id)); });
      $$('.pdp__thumb', pdp).forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)); });
    }
    $$('[data-thumb]', pdp).forEach(function (t) { t.addEventListener('click', function () { setMedia(t.dataset.thumb); }); });

    function currentVariant() {
      var fs = $$('fieldset[data-option-index]', pdp);
      if (!fs.length) return variants[0];
      var chosen = fs.map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
      fs.forEach(function (f, n) { var l = $('[data-option-label]', f); if (l) l.textContent = chosen[n]; });
      return variants.filter(function (v) { return v.options.every(function (o, n) { return o === chosen[n]; }); })[0];
    }
    function update() {
      var v = currentVariant();
      if (!v) { atc.disabled = true; atcText.textContent = 'Unavailable'; return; }
      vInput.value = v.id;
      $('[data-price]', pdp).textContent = formatMoney(v.price);
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      $('[data-price]', pdp).classList.toggle('price__now--sale', !!sale);
      var cmp = $('[data-compare]', pdp), save = $('[data-save]', pdp);
      cmp.hidden = save.hidden = !sale;
      if (sale) { cmp.textContent = formatMoney(v.compare_at_price); save.textContent = 'Save ' + formatMoney(v.compare_at_price - v.price); }
      var S = theme.strings || {};
      atc.disabled = !v.available; atcText.textContent = v.available ? (S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out');
      var st = $('[data-stock]', pdp); st.className = 'stock ' + (v.available ? 'stock--in' : 'stock--out'); st.textContent = v.available ? '● In stock' : '● Out of stock';
      if (v.featured_media) setMedia(v.featured_media.id);
      history.replaceState(null, '', pdp.dataset.productUrl + '?variant=' + v.id);
    }
    $$('[data-option]', pdp).forEach(function (r) { r.addEventListener('change', update); });

    var qIn = $('[data-qty] input', pdp);
    $('[data-qty-minus]', pdp).addEventListener('click', function () { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) - 1); });
    $('[data-qty-plus]', pdp).addEventListener('click', function () { qIn.value = (parseInt(qIn.value, 10) || 1) + 1; });

    form.addEventListener('submit', function (e) {
      if (!window.theme.cartDrawer) return; // normal form post -> /cart
      e.preventDefault();
      errEl.hidden = true; atc.classList.add('is-loading'); atc.disabled = true;
      cartRequest('/cart/add.js', { id: parseInt(vInput.value, 10), quantity: parseInt(qIn.value, 10) || 1 })
        .then(afterAdd)
        .catch(function (err) { errEl.textContent = (err && err.description) || 'Could not add to cart'; errEl.hidden = false; })
        .then(function () { atc.classList.remove('is-loading'); update(); });
    });
  }

  /* ---------- Product recommendations ---------- */
  var rec = $('[data-recommendations]');
  if (rec) {
    fetch(rec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sec = $('.section', doc);
      if (sec) {
        rec.replaceWith(sec);
        $$('.reveal', sec).forEach(function (el) { el.classList.add('is-in'); });
      }
    }).catch(function () {});
  }

  /* ---------- Video banner (click to load) ---------- */
  $$('[data-video]').forEach(function (v) {
    var btn = $('[data-video-play]', v);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = v.dataset.embed; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = 'Video';
      v.innerHTML = ''; v.appendChild(f);
    });
  });

  /* ---------- Collection filters ---------- */
  $$('[data-filter-form] [data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () {
      if (el.name === 'sort_by') {
        var u = new URL(location.href); u.searchParams.set('sort_by', el.value); u.searchParams.delete('page'); location.href = u.toString();
      } else if (el.form && el.form.matches('[data-filter-form]') && window.innerWidth > 989) { el.form.submit(); }
    });
  });
})();
